var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.758,
    height: 24.062,
    viewBox: "0 0 13.758 24.062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M18.223,20.857l9.1-9.105a1.712,1.712,0,0,1,2.429,0,1.734,1.734,0,0,1,0,2.436L19.441,24.5a1.716,1.716,0,0,1-2.371.05L6.689,14.194a1.72,1.72,0,0,1,2.429-2.436Z",
    transform: "translate(25.004 -6.188) rotate(90)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevArrow);
export default __webpack_public_path__ + "static/media/prev-arrow.4fda416b43776d58f6625f2882eeef0c.svg";
export { ForwardRef as ReactComponent };